import React from "react";

const keyFocusData = [
  {
    id: 1,
    title: "Foundations of International Relations:",
    description:
      "Gain a deep understanding of international relations theories and practices, focusing on governance, power dynamics, and global cooperation.",
  },
  {
    id: 2,
    title: "Leadership in Diplomacy:",
    description:
      "Develop strategic decision-making skills tailored for foreign office and governance leadership roles.",
  },
  {
    id: 3,
    title: "Climate and Environmental Diplomacy:",
    description:
      "Address critical global issues like climate change and sustainability through collaborative diplomacy frameworks.",
  },
  {
    id: 4,
    title: "Migration and Security Management:",
    description:
      "Explore migration policies, security challenges, and strategies for effective management of global and regional migration.",
  },
  {
    id: 5,
    title: "Gender and Leadership in Diplomacy:",
    description:
      "Promote inclusivity by examining gender dynamics and empowering leadership in diplomacy.",
  },
  {
    id: 6,
    title: "Human Rights and Governance:",
    description:
      "Analyse the intersection of human rights, governance frameworks, and the role of law in global diplomacy.",
  },
  {
    id: 7,
    title: "Global Insights through Study Tours:",
    description:
      "Gain real-world exposure to diplomatic practices and governance during visits to institutions like the European Union and United Nations.",
  },
];

const KeyFocus = () => {
  const iconUrl = "/essential-icons/verified-svgrepo-com2.svg";

  const backgroundImageUrl =
    "/image-fix/dark-overlay-bg-images/dark-overlayed-bg-3.png";

  return (
    <div
      className="bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      <div className="mx-auto max-w-6xl md:p-10 p-3 space-y-3">
        <div className="space-y-3">
          <div>
            <p className="text-white font-bold text-lg md:text-xl">Key Focus</p>
          </div>
          <div className="bg-sdbodywhite h-0.5 w-10"></div>
        </div>

        <div className="space-y-3">
          {keyFocusData.map((focus) => (
            <div key={focus.id} className="space-y-2">
              <div className="flex space-x-2 items-center">
                <img src={iconUrl} className="h-5 w-5" alt="icon" />
                <div className="bg-[#498ED8] text-white p-2 border-l-2 border-white">
                  <p>{focus.title}</p>
                </div>
              </div>

              <div className="text-white ml-7 border-l-2 border-white text-sm md:text-base">
                <div className="bg-[#18589D] p-2">
                  <p>{focus.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFocus;
